import styled from 'styled-components';
import { screenSize } from '@app/styles';

type Props = {
  disabled?: boolean;
};
type ProgressProps = {
  percentage: number;
};
type ProgressType = {
  type: 'aggregate' | 'single';
};
export const DocumentContainer = styled.div`
  @media (${screenSize.maxMobile}) {
    padding: 5px 15px 10px 15px;
  }
  @media (${screenSize.tablet}) {
    margin-top: 35px;
  }
`;
export const Dropzone = styled.div`
  width: 95%;
  display: flex;
  align-items: center;
  color: #172b4d;
  font-size: 0.85rem;
  justify-content: center;
  flex-direction: column;
`;
export const Percentage = styled.div``;
export const ProgressBar = styled.div`
  height: 6px;
  width: 100%;
  position: relative;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #dce0e8;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (${screenSize.tablet}) {
    height: 8px;
    width: 320px;
    border: 0;
  }
  ${({ type }: ProgressType) => {
    if (type === 'single') {
      return `
                    border:1px solid #dce0e8;
                    position:absolute;
                    bottom:8px;
                    left:19px;
                    width:calc(100% - 38px);
                    span{
                        display:none;
                    }
                    @media (${screenSize.tablet}){
                        position:relative;
                        left:initial;
                        bottom:inherit;
                        border:1px solid #dce0e8;
                        width:150px;
                        span{
                            display:block;
                            span{
                                display:none;
                            }
                        }
                    }
                    
            `;
    }
  }}
`;
export const CancelUpload = styled.div`
  margin-right: 10px;
`;
export const DragAndDropContainer = styled.div`
  .dropzone {
    text-align: center;
    padding: 20px;
    border: 3px dashed #eeeeee;
    background-color: #fafafa;
    color: #bdbdbd;
    margin-bottom: 20px;
  }
`;
export const UploadButton = styled.div`
  background: #ffb900;
  border-radius: 4px;
  padding: 10px 10px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 174px;
  height: 40px;
  cursor: pointer;
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 19px;
  color: #483311;
  @media (${screenSize.tablet}) {
    padding: 10px 24px;
  }
`;
export const DocumentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Progress = styled.div`
  background: #40ddc6;
  position: relative;
  height: 100%;
  ${({ percentage }: ProgressProps) => {
    if (percentage) {
      return `width:${percentage}%;`;
    } else {
      return `width:0`;
    }
  }}
`;
export const UploadFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 10px;
`;
export const DragAndDrop = styled.p`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #110f1f;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
      color:#ccc;
        pointer-events: none;
      `;
    }
  }}
`;
export const ImportFromPc = styled.p`
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
  position: relative;
  bottom: 15px;
  cursor: pointer;
  text-decoration-line: underline;
  color: #0059b8;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
      color:#ccc;
        pointer-events: none;
        text-decoration-line:none;'
      `;
    }
  }}
`;
export const FileTypes = styled.div`
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #110f1f;
  opacity: 0.5;
  bottom: 15px;
  position: relative;
`;
export const NotesContainer = styled.div`
  position: relative;
  left: 15px;
  width: 95%;
`;
export const UploadBody = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 5px;
  svg {
    width: 60px;
    height: 60px;
  }
  @media (${screenSize.tablet}) {
    svg {
      width: 100px;
      height: 100px;
    }
  }
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
      svg {
        path {
          fill: #666;
        }
      }`;
    }
  }}
`;
export const DocumentIcon = styled.div`
  margin-top: 10px;
`;
export const ViewIcon = styled.div``;
export const ViewDocument = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #fafbfc;
  border: 1px solid #dee0e8;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 6px;
  margin-top: 8px;
  border: 1px solid #0a57cd;
  svg {
    width: 20px;
    height: 15px;
  }
`;
export const DownloadDocument = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #fafbfc;
  border: 1px solid #dee0e8;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 6px;
  margin-top: 8px;
  border: 1px solid #eb5757;
  a {
    margin-left: 3px;
    text-decoration: none;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    color: #eb5757;
  }
`;
export const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const View = styled.div`
  margin-left: 3px;
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
  color: #0A57CD;
}
`;

export const UploaderContainer1 = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  background: white;
  overflow: hidden;
  border: 2px dashed #e3e5e9;
  &.dzu-dropzoneActive {
    border-color: #ccc;
  }
  .dzu-inputLabelWithFiles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin: 0;
    background: white;
  }
`;

export const UploadContainer = styled.div`
  border: 2px dashed #16325c;
  border-radius: 8px;
  outline: none;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 95%;
  margin: 15px;
  font-size: 12px;
  .dzu-dropzone {
    border: none;
  }
  .dzu-submitButtonContainer {
    display: none;
  }
  @media (${screenSize.tablet}) {
    // min-height: 150px;
    font-size: 16px;
  }
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
        color:#ccc;
        pointer-events: none;
        border: 2px dashed #ccc;
      `;
    }
  }}
`;
export const RemoveButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
`;
export const DialogContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
`;
export const CancelRemove = styled.div`
  margin-right: 10px;
`;
export const FileName = styled.div`
  margin-top: 10px;
`;
export const SelectDocType = styled.div`
  width: 95%;
  position: relative;
  left: 15px;
  display: flex;
  height: 70px;
`;
export const UploadDocContainer = styled.div`
  background: #f7f8f9;
  padding: 20px;
  width: 95%;
  margin-top: 10px;
  border-radius: 16px;
  cursor: pointer;
`;
export const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media (${screenSize.tablet}) {
    flex-direction: row;
  }
`;
export const SubDiv = styled.div`
  width: 100%;
  @media (${screenSize.maxMobile}) {
    margin-top: 8px;
  }
  @media (${screenSize.tablet}) {
    margin: 5px;
  }
`;
export const DocTitle = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 23px;
  color: #202731;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 250px;
  margin-top: 4px;
  @media (${screenSize.tablet}) {
    font-size: 18px;
    width: 300px;
  }
`;
export const DocumentImg = styled.div`
  display: flex;
`;
export const DocTitleHead = styled.div`
  margin-left: 10px;
`;
export const DocType = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: #666;
`;
export const DocTimeStamp = styled.div`
  color: #666;
  font-size: 14px;
  line-height: 18px;
  margin-top: 5px;
`;
export const DocTimeStampInner = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #080707;
  margin-top: 4px;
`;
export const UploadOnText = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: #110f1f;
  opacity: 0.5;
`;
export const DocumentsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const ArrowDown = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;
export const NoDataContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px;
  align-items: center;
  flex-direction: column;
  background: #fcfcfc;
  border: 1px solid #dee1e4;
  border-radius: 8px;
  width: 95%;
`;
export const UserEmail = styled.div``;
export const EmptyDiv = styled.div`
  display: flex;
  justify-content: center;
`;
export const TitleHeader = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #110f1f;
  opacity: 0.5;
`;
export const DocumentTitleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media (${screenSize.desktop}) {
    flex-direction: row;
  }
`;
export const DocumentTitleFooter = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-top: 25px;
`;
export const UploadBy = styled.div`
  margin-top: 20px;
  margin-left: 10px;
`;
export const UploadedOn = styled.div`
  margin-top: 20px;
  margin-left: 10px;
  @media (${screenSize.desktop}) {
    margin: 0px;
  }
`;
export const FooterSeperator = styled.div`
  border-top: 1px solid #e4e6eb;
  margin-top: 25px;
`;

export const UploadedBy = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #110f1f;
  opacity: 0.5;
`;
export const UserName = styled.div`
  font-size: 16px;
  margin-top: 4px;
  line-height: 24px;
  color: #080707;
`;
export const DocumentDetailsContainer = styled.div`
  background: #fcfcfc;
  border: 1px solid #dee1e4;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 10px;
  margin-top: 10px;
  width: 95%;
  @media (${screenSize.tablet}) {
    padding: 20px;
  }
`;
export const ArrowUpIcon = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
`;

export const RemoveDocument = styled.div`
  margin-right: 20px;
  color: #eb5757;
  font-size: 15px;
  line-height: 19px;
  font-weight: bold;
  cursor: pointer;
`;
